const enFlag = '/assets/icons/en.png';
const deFlag = '/assets/icons/de.png';

export { enFlag, deFlag };
